<template>
    <v-touch class="yxybox" v-if="showProps&&shwoBox" @tap="goBack()">
        <v-touch @tap="close()" class="closeBoxe"></v-touch>
    </v-touch>
</template>

<script>
    export default {
        components: {

        },
        data() {
            return {
                shwoBox:true
            }
        },
        props:{
            showProps:{
                type: Boolean,
                default:false
            }
        },
        watch:{
        },
        computed: {

        },
        mounted() {
        },
        methods: {
            close(){
                this.shwoBox = false;
            },
            goBack(){
                this.$emit('closeYxybox')
            }
        }
    }
</script>

<style lang="scss">
    @import '../../scss/function';
    .yxybox{
        width: topx(750rem);
        height: topx(120rem);
        background: url('../../assets/show/yxybox-bg.gif') no-repeat center;
        background-size: 100% 100%;
        position: fixed;
        bottom: topx(90rem);
        left: 50%;
        margin-left: -50%;
        z-index: 3;
        padding-bottom: env(safe-area-inset-bottom);
        .closeBoxe{
            width: topx(30rem);
            height: topx(30rem);
            position: absolute;
            border-radius: topx(30rem);
            right: topx(10rem);
            top: topx(45rem);
            overflow: hidden;
            line-height: topx(30rem);
            text-align: center;
            color: #ffffff;
            background: url('../../assets/btn_close.png') no-repeat center;
            background-size: 100% 100%;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/show/yxyBox.vue